<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
  data() {
    return {
      user: {
        permissions: {}
      },
    }
  },
  components: {},
  mounted: function() {
    this.$store.dispatch('USER_DATA').then((res) => {
      this.user = res;
    })
    
    document.body.setAttribute("data-sidebar", "dark");
    document.body.setAttribute("data-topbar", "light");
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) parent5.classList.add("mm-active");
          }
        }
      }
    }
  },
  methods: {
    lightSidebar() {
      document.body.setAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-sidebar");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
    },
    compactSidebar() {
      document.body.setAttribute("data-sidebar-size", "small");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.classList.remove("vertical-collpsed");
      document.body.removeAttribute("data-topbar", "dark");
    },
    iconSidebar() {
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-topbar", "dark");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedLayout() {
      document.body.setAttribute("data-keep-enlarged", "true");
      document.body.classList.add("vertical-collpsed");
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar", "colored");
      document.body.setAttribute("data-sidebar", "dark");
      document.body.removeAttribute("data-topbar", "dark");
    },
    coloredSidebar() {
      document.body.setAttribute("data-sidebar", "colored");
      document.body.removeAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-sidebar-size", "small");
      document.body.classList.remove("vertical-collpsed");
    }
  }
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <li class="menu-title">Menu</li>

      <li>
        <router-link tag="a" to="/" class="side-nav-link-ref">
          <i class="bx bx-home-circle"></i>
          <span>Dashboard</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/board" class="side-nav-link-ref">
          <i class="bx bx-chalkboard"></i>
          <span>Painel de Pedidos</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/sales" class="side-nav-link-ref">
          <i class="bx bx-cart"></i>
          <span>Pedidos</span>
        </router-link>
      </li>

      <!-- <li>
        <router-link tag="a" to="/products" class="side-nav-link-ref">
          <i class="bx bx-package"></i>
          <span>Produtos</span>
        </router-link>
      </li> -->

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-package"></i>
          <span>Produtos</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li>
            <router-link tag="a" to="/products" class="side-nav-link-ref">Cadastro</router-link>
          </li>
          <li>
            <router-link tag="a" to="/categories" class="side-nav-link-ref">Categorias</router-link>
          </li>
          <li>
            <router-link tag="a" to="/category-groups" class="side-nav-link-ref">Grupos de Categorias</router-link>
          </li>
          <li>
            <router-link tag="a" to="/complements" class="side-nav-link-ref">Adicionais</router-link>
          </li>
          <li>
            <router-link tag="a" to="/complements-groups" class="side-nav-link-ref">Grupos de Adicionais</router-link>
          </li>
        </ul>
      </li>

      <li>
        <router-link tag="a" to="/customers" class="side-nav-link-ref" v-if="user.permissions.view_customers">
          <i class="bx bx-user-check"></i>
          <span>Clientes</span>
        </router-link>
      </li>

      <!-- <li v-if="user.permission_agents">
        <router-link tag="a" to="/agents" class="side-nav-link-ref">
          <i class="bx bx-user-pin"></i>
          <span>Representantes</span>
        </router-link>
      </li> -->

      <li>
        <router-link tag="a" to="/coupons" class="side-nav-link-ref">
          <i class="bx bx-purchase-tag"></i>
          <span>Cupons</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/banners" class="side-nav-link-ref">
          <i class="bx bx-image-alt"></i>
          <span>Banners</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/users" class="side-nav-link-ref" v-if="user.permissions.view_users">
          <i class="bx bx-group"></i>
          <span>Usuários</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/notifications" class="side-nav-link-ref" v-if="user.permissions.send_notifications">
          <i class="bx bx-message-square-dots"></i>
          <span>Notificações</span>
        </router-link>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-bar-chart-alt-2"></i>
          <span>Relatórios</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li>
            <router-link tag="a" to="/reports/products-sales" class="side-nav-link-ref">Produtos Mais Vendidos</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/abandoned-cart" class="side-nav-link-ref">Carrinhos Abandonados</router-link>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-cog"></i>
          <span>Configurações</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li>
            <router-link tag="a" to="/settings/store" class="side-nav-link-ref">Dados da Loja</router-link>
          </li>
          <!-- <li>
            <router-link tag="a" to="/settings/layout" class="side-nav-link-ref">Layout</router-link>
          </li> -->
          <li>
            <router-link tag="a" to="/settings/messages" class="side-nav-link-ref">Mensagens</router-link>
          </li>
          <!-- <li>
            <router-link tag="a" to="/settings/import" class="side-nav-link-ref">Importação</router-link>
          </li> -->
          <li>
            <router-link tag="a" to="/settings/shipping" class="side-nav-link-ref">Opções de Entrega</router-link>
          </li>
          <li>
            <router-link tag="a" to="/settings/working-hours" class="side-nav-link-ref">Horário de Funcionamento</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
